import React, { useMemo, useState } from 'react';
import { CardFileManagementProps } from './types';
import {
    CellsWrapper,
    CodeCell,
    Controls,
    DocumentName,
    Image,
    ImageWrapper,
    PathCell,
    Title,
    Wrapper,
} from './card-file-management.styles';
import { Typography } from '@shared/ui/typography/typography';
import { IconFile } from '@shared/icon/icon-file/icon-file';
import { parseFileUrl } from '@shared/lib/utils/parse-file-url/parse-file-url';
import { CopyLink } from '@shared/ui/copy-link/copy-link';
import { checkFileIsImage } from '@features/file/create-file/lib/check-file-is-image';
import { AllEyeOpen } from '@vtbhome/juicyfront/indexIcon';
import { COLORS } from '@shared/config/colors/colors';
import { ImagePreview } from '@vtbhome/juicyfront';
import { useLazyPrivateImageQuery } from '@entities/file/api/file-api';

export const CardFileManagement: React.FC<CardFileManagementProps> = ({ file, children }) => {
    const [isShowImagePreview, setIsShowImagePreview] = useState(false);
    const [getPrivateImage, getPrivateImageResult] = useLazyPrivateImageQuery();
    const isImage = checkFileIsImage(file.meta.extension);

    const filePath = useMemo(() => {
        return parseFileUrl(file.url);
    }, [file.url]);

    const fileUrl = useMemo(() => {
        const isPrivate = file.meta.hidden;
        if (isPrivate) {
            if (isImage && !getPrivateImageResult.data) {
                getPrivateImage(file.id);
            }
            return getPrivateImageResult.data || '';
        }
        return file.url;
    }, [file, isImage, getPrivateImageResult.data]);

    return (
        <>
            <Wrapper>
                <Title>
                    <DocumentName>
                        {isImage ? (
                            <ImageWrapper onClick={() => setIsShowImagePreview(true)}>
                                <Image src={fileUrl} />
                                <AllEyeOpen size='xs' color={COLORS.neutral_00} />
                            </ImageWrapper>
                        ) : (
                            <IconFile />
                        )}
                        <Typography size='subtitle2'>{`${file.name}.${file.meta.extension}`}</Typography>
                    </DocumentName>
                    <Controls>
                        <CopyLink
                            url={fileUrl}
                            tooltipMessage='Скопировать ссылку на файл'
                            successMessage='Ссылка на файл скопирована'
                            errorMessage='Не удалось скопировать ссылку на файл'
                        />
                        {children}
                    </Controls>
                </Title>
                <CellsWrapper>
                    <CodeCell>
                        <Typography size='body2_long' color='neutral_50'>
                            Системное название (код)
                        </Typography>
                        <Typography size='body2_long'>{file.code}</Typography>
                    </CodeCell>
                    <PathCell>
                        <Typography size='body2_long' color='neutral_50'>
                            Относительный путь
                        </Typography>
                        <Typography size='body2_long'>{filePath.fileRelativePath}</Typography>
                    </PathCell>
                </CellsWrapper>
            </Wrapper>
            {isShowImagePreview && <ImagePreview images={[fileUrl]} onClose={() => setIsShowImagePreview(false)} />}
        </>
    );
};
